import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-header-company"
}
const _hoisted_2 = { class: "page-header-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "page-header-content" }
const _hoisted_5 = { class: "page-header-title" }
const _hoisted_6 = { class: "page-header-subtitle" }
const _hoisted_7 = {
  key: 1,
  class: "page-header-image"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "page-content" }
const _hoisted_10 = { class: "item-title" }
const _hoisted_11 = { class: "item-page" }
const _hoisted_12 = { class: "page-footer-content" }
const _hoisted_13 = { class: "page-footer-title" }
const _hoisted_14 = { class: "page-footer-subtitle" }

import { styleZoom } from "@/common/utils/style";

interface SummaryItemType {
  id: string;
  label: string;
  page: number;
}

interface SummaryPageType {
  id: string;
  style: any;
  items: SummaryItemType[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'summary',
  props: {
    avatar: {},
    company: {},
    footer: {},
    header: {},
    data: {},
    print: { type: Boolean },
    style: {},
    summary: {},
    zoom: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", {
      print: props.print,
    }]),
    style: _normalizeStyle(_unref(styleZoom)(__props.style, __props.zoom))
  }, [
    (__props.header?.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["page-header", {
          'no-image': !__props.avatar,
        }]),
          style: _normalizeStyle(
          _unref(styleZoom)(
            {
              'font-size': '16px',
            },
            __props.zoom,
          )
        )
        }, [
          (__props.company)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: __props.company.avatar?.base64,
                    alt: "Logo"
                  }, null, 8, _hoisted_3)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.header.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.header.subtitle), 1)
          ]),
          (__props.avatar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: __props.avatar.base64,
                  alt: "Logo"
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "summary-title" }, "Índice", -1)),
      _createElementVNode("div", {
        class: "summary-list",
        style: _normalizeStyle(
          _unref(styleZoom)(
            {
              'font-size': __props.summary.size,
              'font-family': __props.summary.font_family,
            },
            __props.zoom,
          )
        )
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.items, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "summary-item"
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.label), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "item-dot" }, null, -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.page + 1), 1)
          ]))
        }), 128))
      ], 4)
    ]),
    (__props.footer?.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "page-footer",
          style: _normalizeStyle(
          _unref(styleZoom)(
            {
              'font-size': '16px',
            },
            __props.zoom,
          )
        )
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(__props.footer.title), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(__props.footer.subtitle), 1)
          ])
        ], 4))
      : _createCommentVNode("", true)
  ], 6))
}
}

})